import type { EatigoBranchSlot } from '@/types/api'
import type { GroupByDateSlots } from '@/types/product'

export function getGroupedByDateSlots(slots?: EatigoBranchSlot[]) {
  if (!slots) {
    return {}
  }
  return slots.reduce((acc, slot) => {
    const date = slot.slot?.split(' ')[0] ?? ''
    if (!acc[date]) acc[date] = { maxDiscount: 0, slots: [] }
    acc[date].maxDiscount = Math.max(acc[date].maxDiscount, slot.discount ?? 0)
    acc[date].slots.push(slot)
    return acc
  }, {} as GroupByDateSlots)
}

export function convertToWebp(url: string) {
  return url.replace(/\.\w+$/, '.webp')
}
